<template>
  <SideBar :width="getSideBarWidth()">
    <template #side-bar-activator>
      <Activator
        class="self-centered cursor-e-resize"
        :key="`side_bar_activator>`"
        @mousedown.native="location.includes('HistProjectTaktPlan') ? $router.push({name: 'HistProjectTaktPlan'}) :$router.push({name: 'ProjectTaktPlan'})"
        />
    </template>
    <template #content>
      <div style="position: relative; width: 100%; height: 100%; overflow: hidden">
        <BacklogWrapper
          color="grey darken-3"
          :isEditMode="isEditMode"
          type="backlogsheader"
          text="Backlogs"
          :small_width="$route.matched.length > 3?true:false"
          @clickAdd="createUObject({
              url: [
                {projects: project.id},
                {wbgroups: ''},
                {showWithEntitiesNormalized: ''}
              ],
              u_object: {
                name: 'New Group',
                description: 'description'
              },
              trainsbacklogs: true
            }).then(group_id => {
              createUObject({
                url: [
                  {projects: project.id},
                  {wbgroups: group_id},
                  {wblines: ''},
                  {showWithEntitiesNormalized: ''}
                ],
                  u_object: {
                    name: 'New Line',
                    description: 'description',
                    position: 1
                  }
                })
              })
            "
        >
          <template #actions>
            <div style="margin-right: 32px;margin-top: -4px;">
              <TTooltip bottom text="Filter no date">
                <ToggleCapsule
                  :is_active="$store.state.View.backglogs_show_with_date"
                  background_color="#121212"
                  foreground_color="#FFF"
                  @toggleClicked="setValue({ key: 'backglogs_show_with_date', value: !$store.state.View.backglogs_show_with_date})"
                />
              </TTooltip>
            </div>
          </template>
          <template #right v-if="$route.matched[3]">
            <div :class="`pa-1 ${workpackage?workpackage.color:''}`" style="position: relative; width: 100%; display: flex; align-items: center; margin-left: 10px;">
              <v-btn
                @click="handleBackClick()"
                small
                >
                <v-icon>
                  keyboard_arrow_left
                </v-icon>
                Back
              </v-btn>
              <TText v-if="$route.matched[3] && $route.matched[3].name === 'TaktPlanAddWBWorkPackage'" class="ml-2" text="Add WB Workpackage" medium/>
              <template v-else-if="workpackage && isEditMode">
                <v-spacer/>
                <!-- 3 DOT OPTIONS TOGGLE -->
                <v-btn
                  icon
                  @click.prevent.stop="show_header_options = !show_header_options"
                >
                  <TIcon
                    :color="workpackage.textcolor"
                    name="vertical-dots"
                  />
                </v-btn>
                <!-- ACTUAL OPTIONS -->
                <TransitionAccordion>
                  <PopUpOverlay
                    v-if="show_header_options"
                    style="z-index: 20; "
                    :width="`${2 * 140}px`"
                    :margin="8"
                    :position_css="`
                      right: 10px;
                      transform: translate(0%, 100%);
                    `"
                    :is_no_cancel="true"
                    @closeOverlay="show_header_options = false"
                    :z_index="1"
                  >
                    <template #body>
                      <div class="workpackage-sidebar-option-buttons">
                        <ClickablePopUpIcon
                          icon="pencil"
                          color="var(--primary)"
                          description="edit"
                          @selected="edit_wp = workpackage, show_header_options = false"
                        />
                        <ClickablePopUpIcon
                          icon="copy"
                          color="var(--primary)"
                          description="copy"
                          @selected="
                            getNestedWorkPackageCopy(workpackage.id, false, 'wb').then(work_package => {
                              updateWBLObject({
                              path: [
                              {workpackage: ''}
                              ],
                              update: work_package
                              }),
                              $router.push({
                                name: 'TaktPlanBacklogWorkPackageCopyWorkPackageEditor',
                                params: { workpackage_id: 'create' }
                              })
                            }), show_header_options = false
                          "
                        />
                        <DropDownModular
                          style="padding: 0px"
                          :selected="selectedWBLine"
                          :options="getAllWBLines()"
                          justify_content="center"
                          z_index="12"
                          padding="0 8"
                          max_height="400"
                          @updateSelected="changeLineWBWorkpackage($event), show_header_options = false"
                        >
                          <template #head>
                            <div>
                              <TIcon
                                class="ml-4"
                                name="swap-vertical"
                                color="var(--primary)"
                                :size="30"
                              />
                              <TText
                              style="margin-top: 0px"
                              value="change line"
                              :size="9"
                              />
                            </div>
                          </template>
                        </DropDownModular>
                        <div class="workpackage-sidebar-deletebutton-wrapper">
                          <StandardDeleteButton class="mt-1 ml-1"
                            :zoom="1"
                            @clickDelete="deleteUObject({
                              url: [
                                {projects: $route.params.project_id},
                                {wbgroups: $route.params.wbgroup_id},
                                {wblines: $route.params.wbline_id},
                                {wbworkpackages: workpackage.id}
                              ],
                            }).then(() => {
                              $router.push({name: 'TaktPlanBacklogs'})
                            })"
                          />
                          <TText
                            style="margin-top: 5px"
                            value="delete"
                            :size="9"
                            color="var(--primary)"
                          />
                        </div>
                      </div>
                    </template>
                  </PopUpOverlay>
                </TransitionAccordion>
                <EditTWorkPackageDialog
                  v-if="edit_wp"
                  :workpackage="edit_wp"
                  :backlog="true"
                  @closeDialog="edit_wp = false"
                  @changeWP="updateUObject({
                    url: [
                    {projects: $route.params.project_id},
                    {wbgroups: $route.params.wbgroup_id},
                    {wblines: $route.params.wbline_id},
                    {wbworkpackages: workpackage.id}
                    ],
                    update: $event.new_wp,
                    }).then(() => {
                      edit_wp = false;
                      })
                    "
                />
              </template>
            </div>
          </template>
        </BacklogWrapper>
        <div style="position: relative; display: flex; width: 100%; height: 100%; overflow: hidden">
          <div style="position: relative; display: flex; flex-direction: column; flex-shrink: 0; height: 100%; overflow: auto; scrollbar-gutter: stable;">
            <BacklogWrapper
              v-for="wbgroup in getUObjects({type: 'wbgroups', ids: project.wbgroups})"
              :key="`wbgroups-${wbgroup.id}`"
              :isEditMode="isEditMode"
              color="#616161"
              icon="crop_landscape"
              type="wbgroups"
              header_sticky_position="0px"
              :small_width="$route.matched.length > 3?true:false"
              :text="wbgroup.name"
              @clickAdd="createUObject({
                  url: [
                    {projects: project.id},
                    {wbgroups: wbgroup.id},
                    {wblines: ''},
                    {showWithEntitiesNormalized: ''}
                  ],
                  u_object: {
                    name: 'New Line',
                    description: 'description'
                  }
                })"
              @clickDelete="deleteUObject({
                  url: [
                    {projects: project.id},
                    {wbgroups: wbgroup.id}
                  ],
                  trainsbacklogs: true
                })
              "
              @changeValue="updateUObject({
                url: [
                  {projects: project.id},
                  {wbgroups: wbgroup.id}
                ],
                update: {
                  name: $event.target.value
                }
                })"
              >
              <BacklogWrapper
                v-for="wbline in getUObjects({type: 'wblines', ids: wbgroup.wblines})"
                :key="`wblines-${wbline.id}`"
                :isEditMode="isEditMode"
                color="#757575"
                icon="crop_free"
                type="wblines"
                header_sticky_position="50px"
                :small_width="$route.matched.length > 3?true:false"
                :text="wbline.name"
                @clickDelete="
                wbgroup.wblines.length === 1?
                deleteUObject({
                    url: [
                      {projects: project.id},
                      {wbgroups: wbgroup.id}
                    ],
                    trainsbacklogs: true,
                  })
                :
                deleteUObject({
                    url: [
                      {projects: project.id},
                      {wbgroups: wbgroup.id},
                      {wblines: wbline.id}
                    ]
                  })
                "
                @clickAdd="$router.push({
                    name: 'TaktPlanAddWBWorkPackage',
                    params: {
                      wbgroup_id: wbgroup.id,
                      wbline_id: wbline.id
                    }
                  }),
                  setNewWPPosition(false)
                  "
                @changeValue="updateUObject({
                  url: [
                    {projects: project.id},
                    {wbgroups: wbgroup.id},
                    {wblines: wbline.id}
                  ],
                  update: {
                    name: $event.target.value
                  }
                  })"
                >
                <!-- getWBWorkpackagesSorted filtered by position -1 if $store.state.View.backglogs_show_with_date is true -->
                <BacklogWorkpackageList
                  v-for="wbworkpackage in getWBWorkpackagesSorted(wbline).filter(wbworkpackage => {
                    if($store.state.View.backglogs_show_with_date) {
                      return wbworkpackage.position === -1
                    } else {
                      return true
                    }
                  })"
                  :key="`wblines-${wbworkpackage.id}`"
                  :wbworkpackage="wbworkpackage"
                  :date="getWBWorkpackageDate(wbworkpackage, project.id)"
                  :small_width="$route.matched.length > 3?true:false"
                  @click.native="$router.push({
                    name: 'TaktPlanBacklogWorkPackageInfo',
                    params: {
                      wbgroup_id: wbgroup.id,
                      wbline_id: wbline.id,
                      wbworkpackage_id: wbworkpackage.id
                    }
                  })"
                  @updatePosition="updateUObject({
                      url: [
                        {projects: project.id},
                        {wbgroups: wbgroup.id},
                        {wblines: wbline.id},
                        {wbworkpackages: wbworkpackage.id}
                      ],
                      update: {
                        position: $event
                      }
                  })"
                  @updateLength="updateUObject({
                      url: [
                        {projects: project.id},
                        {wbgroups: wbgroup.id},
                        {wblines: wbline.id},
                        {wbworkpackages: wbworkpackage.id}
                      ],
                      update: {
                        length: $event
                      }
                  })"
                  @clickRemove="updateUObject({
                      url: [
                        {projects: project.id},
                        {wbgroups: wbgroup.id},
                        {wblines: wbline.id},
                        {wbworkpackages: wbworkpackage.id}
                      ],
                      update: {
                        position: -1,
                        length: 1,
                      }
                  })"
                />
              </BacklogWrapper>
            </BacklogWrapper>
          </div>

          <div style="position: relative; width: 100%; height: calc(100% - 50px); overflow: hidden">
            <router-view/>
          </div>
        </div>
      </div>
    </template>
  </SideBar>
</template>
<script>
import SideBar from '@/components/ProjectTaktPlan/SideBar.component.vue'
import Activator from '@/components/ProjectTaktPlan/Activator.component.vue'
import TText from '@/components/Taktify/TText.component.vue';
import TIcon from '@/components/Taktify/TIcon.component.vue';
import TTooltip from '@/components/Taktify/TTooltip.component.vue';
import StandardDeleteButton from '@/components/StandardComponents/StandardDeleteButton.component.vue';
import EditTWorkPackageDialog from '@/components/ProjectTaktPlan/EditTWorkPackageDialog.component.vue'
import ToggleCapsule from '@/components/WorkPackageWIP/ToggleCapsule.component.vue';
import TransitionAccordion from '@/components/WorkPackageWIP/TransitionAccordion.component.vue'
import ClickablePopUpIcon from '@/components/WorkPackageWIP/ClickablePopUpIcon.component.vue';
import PopUpOverlay from '@/components/WorkPackageWIP/PopUpOverlay.component.vue';

import BacklogWrapper from '@/components/TaktPlanBacklogs/BacklogWrapper.component.vue';
import BacklogWorkpackageList from '@/components/TaktPlanBacklogs/BacklogWorkpackageList.component.vue';
import DropDownModular from '@/components/WorkPackageWIP/DropDownModular.component.vue';

import { mapGetters, mapActions } from 'vuex';
import { SideBarMixin } from '@/mixins/SideBar.mixin.js'
import { BacklogMixin } from '@/mixins/Backlog.mixin.js'
import { WaggonInfoMixin } from '@/mixins/WaggonInfo.mixin.js'

export default {
  props: ['location'],
  components: {
    SideBar,
    Activator,
    TText,
    TTooltip,
    BacklogWrapper,
    BacklogWorkpackageList,
    StandardDeleteButton,
    EditTWorkPackageDialog,
    ToggleCapsule,
    TIcon,
    DropDownModular,
    TransitionAccordion,
    ClickablePopUpIcon,
    PopUpOverlay
  },
  mixins: [
    SideBarMixin,
    BacklogMixin,
    WaggonInfoMixin
  ],
  data: () => ({
    edit_wp: false,
    backlog: true,
    selectedWBLine: {},
    show_header_options: false,
  }),
  computed: {
    project() {return this.$store.state.Ultra.projects[this.$route.params.project_id];},
    ...mapGetters('Project', [
      'isEditMode',
    ]),
    ...mapGetters('ProjectCalendar', [
      'getCalendar',
    ]),
    ...mapGetters('Ultra', [
      'getUObjects',
    ]),
    workpackage() {
      if (this.$route.params.wbworkpackage_id) {
        return this.$store.state.Ultra.wbworkpackages[this.$route.params.wbworkpackage_id];
      } else {
        return false;
      }
    }
  },
  methods: {
    ...mapActions('Ultra', [
      'createUObject',
      'deleteUObject',
      'updateUObject',
      'updateUObjectParent'
    ]),
    ...mapActions('UltraDev', [
      'updateUDObject'
    ]),
    ...mapActions('ProjectBacklog', [
      'setNewWPPosition'
    ]),
    ...mapActions('View', [
      'setValue'
    ]),
    handleBackClick(){
      if (this.$route.name === 'TaktPlanAddWBWorkPackage') {
        this.$router.push({name: 'TaktPlanBacklogs'});
      } else if (this.location.includes('HistProjectTaktPlan')) {
        this.$router.push({name: 'HistProjectTaktPlan'});
      } else {
        this.$router.push({name: 'TaktPlanBacklogs'});
        // this.$router.push({name: 'TaktPlanAddWBWorkPackage'});
      }
    },
    getWBWorkpackagesSorted(wbline) {
      let objects = [];
      let all_wbworkpackages = this.getUObjects({type: 'wbworkpackages', ids: wbline.wbworkpackages});
      objects = objects.concat(all_wbworkpackages.filter(wp => wp.position !== -1).sort(function(a,b) {
        if (a.position > b.position) {
          return 1;
        }
        if (a.position < b.position) {
          return -1;
        }
        // if position is equal sort by length
        if (a.length > b.length) {
          return -1;
        }
        if (a.length < b.length) {
          return 1;
        }
        return 0;
      }));
      objects = objects.concat(all_wbworkpackages.filter(wp => wp.position === -1));
      return objects;
    },
    getAllWBLines() {
      let wbgroups = this.getUObjects({type: 'wbgroups', ids: this.project.wbgroups})
      let result = [];
      for (let wbgroup_index in wbgroups) {
        result.push({
          id: wbgroups[wbgroup_index].id,
          text: wbgroups[wbgroup_index].name,
          disabled: true
        });
        result = result.concat(this.getUObjects({type: 'wblines', ids: wbgroups[wbgroup_index].wblines}).map(wbline => {
          return {
            id: wbline.id,
            text: wbline.name,
            disabled: false
          }
        }));
      }
      return result;
    },
    changeLineWBWorkpackage(newLineId){
      this.updateUObjectParent({
        url: [
          {projects: this.$route.params.project_id},
          {wbgroups: this.$route.params.wbgroup_id},
          {wblines: this.$route.params.wbline_id},
          {wbworkpackages: this.$route.params.wbworkpackage_id},
          {changeline: ""}
        ],
        update: {
          parent_id: newLineId,
        }
      }).then(() => {
        this.$router.push({
          name: 'TaktPlanBacklogWorkPackageInfo',
          params: {
            wbgroup_id: this.$route.params.wbgroup_id,
            wbline_id: newLineId,
            wbworkpackage_id: this.$route.params.wbworkpackage_id
          }
        })
      })
    }
  }
}
</script>
<style>
  .workpackage-sidebar-option-buttons {
    display: flex;
    width: 100%;
    align-items: center;
    /* grid-gap: 8px;
    padding: 16px; */
    justify-content: space-between;
  }
  .workpackage-sidebar-deletebutton-wrapper{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
</style>